import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import axios from 'axios';
import '@/App.css';
import Welcome from './pages/Welcome';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Optimizador from './pages/Optimizador';
import Proyecciones from './pages/Proyecciones';
import Administracion from './pages/Administracion';
import MiCuenta from './pages/MiCuenta';
import { Facturas } from './pages/Facturas';
import TipologiasFacturas from './pages/TipologiasFacturas';
import Clientes from './pages/Clientes';
import Proveedores from './pages/Proveedores';
import { Toaster } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8000';
// Si usa api-proxy.php, mantener /api en la URL. El proxy manejará la ruta completa
const API = BACKEND_URL.includes('api-proxy.php') 
  ? BACKEND_URL 
  : `${BACKEND_URL}/api`;

export const AuthContext = React.createContext();

function App() {
  const [usuario, setUsuario] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const verificarAuth = async () => {
      const storedToken = localStorage.getItem('token');
      if (storedToken) {
        try {
          const response = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${storedToken}` }
          });
          setUsuario(response.data);
          setToken(storedToken);
        } catch (error) {
          localStorage.removeItem('token');
          setToken(null);
        }
      }
      setLoading(false);
    };
    verificarAuth();
  }, []);

  const login = (newToken, userData) => {
    localStorage.setItem('token', newToken);
    setToken(newToken);
    setUsuario(userData);
  };

  const logout = () => {
    localStorage.removeItem('token');
    setToken(null);
    setUsuario(null);
  };

  if (loading) {
    return (
      <div className="loading-screen" data-testid="loading-screen">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ usuario, token, login, logout, API }}>
      <BrowserRouter>
        <Routes>
          <Route path="/welcome" element={!token ? <Welcome /> : <Navigate to="/" />} />
          <Route path="/login" element={!token ? <Login /> : <Navigate to="/" />} />
          <Route path="/" element={token ? <Dashboard /> : <Navigate to="/welcome" />} />
          <Route path="/productos" element={token ? <Productos /> : <Navigate to="/welcome" />} />
          <Route path="/optimizador" element={token ? <Optimizador /> : <Navigate to="/welcome" />} />
          <Route path="/proyecciones" element={token ? <Proyecciones /> : <Navigate to="/welcome" />} />
          <Route path="/facturas" element={token ? <Facturas /> : <Navigate to="/welcome" />} />
          <Route path="/configuracion/tipologias" element={token ? <TipologiasFacturas /> : <Navigate to="/welcome" />} />
          <Route path="/configuracion/clientes" element={token ? <Clientes /> : <Navigate to="/welcome" />} />
          <Route path="/configuracion/proveedores" element={token ? <Proveedores /> : <Navigate to="/welcome" />} />
          <Route path="/administracion" element={token ? <Administracion /> : <Navigate to="/welcome" />} />
          <Route path="/mi-cuenta" element={token ? <MiCuenta /> : <Navigate to="/welcome" />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthContext.Provider>
  );
}

export default App;
